import React from 'react'

export default class ScrollableBody extends React.Component {
  render () {
    return (
      <div className='scrollable-body'>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/commons/components/SegmentsPopupContent/ScrollableBody.js